import { i18n } from '@/plugins/i18n'
import _ from 'lodash'

export const findObjectByKeyValue = (object: any, key: string, value: any): any => {
  if (Array.isArray(object)) {
    for (const obj of object) {
      const result = findObjectByKeyValue(obj, key, value)
      if (result) {
        return obj
      }
    }
  } else {
    if (Object.prototype.hasOwnProperty.call(object, key) && object[key] === value) {
      return object
    }

    for (const k of Object.keys(object)) {
      if (typeof object[k] === 'object') {
        const o = findObjectByKeyValue(object[k], key, value)
        if (o !== null && typeof o !== 'undefined') return o
      }
    }
    return null
  }
}

export const findSubdomain = (url: string): string => {
  // eslint-disable-next-line
  const regexParse = new RegExp('([a-z-0-9]{2,63})[.]+([a-z.]{2,5})$')
  const regexExceptArray = regexParse.exec(url)
  if (regexExceptArray !== null) {
    return regexExceptArray[0]
  }
  return ''
}

export const getDateWithoutTime = (dt: string): string => {
  const dtTmp = new Date(Date.parse(dt))
  return dtTmp.toLocaleDateString()
}

export const getDateWithTime = (dt: string): string => {
  const dtTmp = new Date(Date.parse(dt))
  return dtTmp.toLocaleString()
}

/* check if is null object or array */
export const isNull = (thing: any): boolean => {
  if (!thing) {
    return true
  }
  return Object.keys(thing).length > 0 ? false : true
}

/**
 * check if is Primitive type
 */
export const isPrimitive = (thing: any): boolean => {
  return thing !== Object(thing)
}

/**
 * Check is empty string
 */
export const isEmptyString = (thing: string): boolean => {
  return thing === ''
}

/**
 * Check is empty anything
 */
export const isEmptyValue = (thing: any): boolean => {
  const type: string = typeof thing
  if (type === 'number') {
    return false
  }
  if (type === 'string') {
    return isNull(thing)
  }
  if (type === 'object') {
    const obj: any = deepCopyObject(thing) // Make custom object readable
    if (Array.isArray(obj)) {
      for (const item of obj) {
        if (!isEmptyValue(item)) {
          return false
        }
      }
      return true
    } else {
      return isNull(obj)
    }
  }
  return true
}

export const deepCopyObject = (source: any): any => {
  return JSON.parse(JSON.stringify(source))
}

export const isUsingPhoneOrTablet = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase()
  const deviceToMatch = [
    /android/i,
    /webOS/i,
    /iphone/i,
    /ipad/i,
    /ipod/i,
    /blackberry/i,
    /windows phone/i
  ]
  return deviceToMatch.some((toMatchItem) => {
    return userAgent.match(toMatchItem)
  })
}

/**
 * Format seconds to string format: mm:ss
 * @params {number} secs
 */
export const formatSeconds2Str = (secs: number): string => {
  const _t: any = i18n.global
  const minutes = parseInt(String(secs / 60), 10)
  const seconds = parseInt(String(secs % 60), 10)
  const minuteStr = minutes < 10 ? '0' + String(minutes) : String(minutes)
  const secondStr = seconds < 10 ? '0' + String(seconds) : String(seconds)
  return `${minuteStr}` + _t.t('time.minute') + `${secondStr}` + _t.t('time.second')
}

export const numFormat = (cellValue: number): string => {
  return parseFloat(cellValue.toFixed(2)).toLocaleString()
}

export const formatDate = (date: Date): string => {
  return date.toLocaleDateString('zh-TW', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
}

export const formatDateWithTime = (date: Date): string => {
  return date.toLocaleDateString('zh-TW', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
}
export function mapKeysToApiKey(
  collection: CollectionItem[],
  data: DataItem[]
): Record<string, string>[] {
  return data.map((item) => {
    const newItem: Record<string, string> = {}
    Object.keys(item).forEach((key) => {
      const name = collection.find((c) => c.apiKey === key)?.name
      if (name) {
        newItem[name] = item[key]
      }
    })
    return newItem
  })
}
export interface CollectionItem {
  name: string
  apiKey: string
}
export interface DataItem {
  [key: string]: string
}
export function maskName(value: string) {
  let byteCount = 0
  let result = ''
  // 計算前 4 Bytes 替換為 'xx'
  for (let i = 0; i < value.length; i++) {
    const char = value[i]
    const isChinese = char.charCodeAt(0) > 255 // 判斷是否為中文
    byteCount += isChinese ? 2 : 1

    if (byteCount > 4) {
      result += value.slice(i)
      break
    }
  }
  // 取得第 5 到第 8 Bytes 的字元
  const masked = 'ｘｘ'
  let preserved = ''
  byteCount = 0
  for (const char of result) {
    const isChinese = char.charCodeAt(0) > 255
    const charBytes = isChinese ? 2 : 1

    if (byteCount + charBytes <= 4) {
      preserved += char
      byteCount += charBytes
    } else {
      break
    }
  }

  // 第 9 Bytes 之後替換為 'ｘ'
  const remaining = Array.from(result.slice(byteCount))
    .map(() => 'ｘ')
    .join('')

  return masked + preserved + remaining
}
export function maskEmail(email: string) {
  const account = email.split('@')[0]
  let byteCount = 0
  let result = ''
  // 計算前 4 Bytes 替換為 'xx'
  for (let i = 0; i < account.length; i++) {
    const char = account[i]
    const isChinese = char.charCodeAt(0) > 255 // 判斷是否為中文
    byteCount += isChinese ? 2 : 1

    if (byteCount > 6) {
      result += account.slice(i)
      break
    }
  }
  // 取得第 5 到第 8 Bytes 的字元
  const masked = 'ｘｘｘｘｘｘ'

  const maskAccount = masked + result
  const domain = email.split('@')[1]
  return maskAccount + '@' + _.replace(domain, /./g, 'ｘ')
}
export function maskPhone(phone: string) {
  return phone.slice(0, 5) + phone.slice(5).replace(/./g, '0')
}
export async function generateHash(message: string) {
  const encoder = new TextEncoder()
  const data = encoder.encode(message)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('')
  return hashHex
}
